<section class="step-features" *ngIf="!loading; else loadingTpl">
    <header class="step-header">
        <h2>Plan &amp; Features</h2>
        <p class="muted">
            Pick which feature areas your new organization should start with. You can change this any time later in
            organization settings. The plan is <strong>Free</strong> for now — no billing.
        </p>
    </header>

    <div class="counter-row">
        <div class="counter">
            <strong>{{ selectedCount }}</strong> / {{ totalCount }} features selected
        </div>
        <div class="counter-actions">
            <button mat-stroked-button type="button" (click)="selectMinimum()">Select minimum</button>
            <button mat-stroked-button type="button" (click)="selectAll()">Select all</button>
        </div>
    </div>

    <div class="error-banner" *ngIf="loadError">
        <mat-icon>warning</mat-icon>
        <span>{{ loadError }}</span>
    </div>

    <ul class="bundle-list">
        <li class="bundle" *ngFor="let bundle of bundles" [class.locked]="bundle.locked">
            <div class="bundle-row">
                <button
                    type="button"
                    class="bundle-toggle"
                    [class.all]="isBundleSelected(bundle) === 'all'"
                    [class.some]="isBundleSelected(bundle) === 'some'"
                    [disabled]="bundle.locked"
                    [matTooltip]="bundle.locked ? 'Required — cannot be turned off' : 'Toggle whole bundle'"
                    (click)="toggleBundle(bundle)">
                    <mat-icon *ngIf="isBundleSelected(bundle) === 'all'">check_box</mat-icon>
                    <mat-icon *ngIf="isBundleSelected(bundle) === 'some'">indeterminate_check_box</mat-icon>
                    <mat-icon *ngIf="isBundleSelected(bundle) === 'none'">check_box_outline_blank</mat-icon>
                </button>
                <div class="bundle-meta">
                    <div class="bundle-name">
                        {{ bundle.name }}
                        <span class="muted feature-count">({{ bundle.features.length }} features)</span>
                    </div>
                    <div class="bundle-description" *ngIf="bundle.description">{{ bundle.description }}</div>
                </div>
                <button
                    type="button"
                    mat-icon-button
                    class="advanced-toggle"
                    [matTooltip]="expanded.has(bundle.id) ? 'Hide individual features' : 'Show individual features'"
                    (click)="toggleExpanded(bundle)">
                    <mat-icon>{{ expanded.has(bundle.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </div>

            <ul class="feature-list" *ngIf="expanded.has(bundle.id)">
                <li class="feature" *ngFor="let feature of bundle.features">
                    <button
                        type="button"
                        class="feature-toggle"
                        [class.selected]="selected.has(feature.key)"
                        [disabled]="bundle.locked"
                        (click)="toggleFeature(feature.key, bundle.locked)">
                        <mat-icon *ngIf="selected.has(feature.key)">check_box</mat-icon>
                        <mat-icon *ngIf="!selected.has(feature.key)">check_box_outline_blank</mat-icon>
                        <span class="feature-name">{{ feature.name }}</span>
                        <span class="feature-permissions muted" *ngIf="feature.permissions?.length">
                            {{ feature.permissions.length }} permissions
                        </span>
                    </button>
                    <p class="feature-description muted" *ngIf="feature.description">{{ feature.description }}</p>
                </li>
            </ul>
        </li>
    </ul>
</section>

<ng-template #loadingTpl>
    <div class="loading">
        <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
        <span>Loading features…</span>
    </div>
</ng-template>
